import React from 'react'
import styled from 'styled-components'

export const ButtonBase = styled.button`
    background: var(--surface);
    color: var(--primary);
    border-radius: var(--border-radius);
    padding: 12px 15px;
    min-width: 140px;
    outline: none;
    border: 1px solid var(--border-color);
    font-size: 16px;
    line-height: 16px;
    cursor: pointer;
    transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;

    &:focus-visible {
        border-color: var(--accent);
        box-shadow: 0 0 0 3px color-mix(in oklab, var(--accent) 20%, white);
    }

    &:disabled {
        cursor: not-allowed;
        background: var(--bg-disabled);
        color: var(--text-disabled);
        opacity: 1;
    }
`
